import { render, staticRenderFns } from "./DashboardInstitution.vue?vue&type=template&id=7bad8781&"
import script from "./DashboardInstitution.vue?vue&type=script&lang=js&"
export * from "./DashboardInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports